@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.tooltip-target-wrapper {
  display: inline-block;
  color: @customer-recipient--default--fill-color;
  position: relative;
  top: -3px;
  width: 30px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
}

.icon {
  transform: scale(0.5);
  height: 25px;
  width: 25px;
}

.tooltip-content {
  font-size: 14px;
  padding: @space-12;
  width: 210px;
}
